import React from "react";
import { Modal } from "react-bootstrap";
import { gettext, interpolate } from "../utils/legacy";
import CancelButton from "../buttons/CancelButton";
import SaveButton from "../buttons/SaveButton";
import DeleteButton from "../buttons/DeleteButton";
import { PermissionObject } from "../../fileupload/utils";

interface ModelEditModalFooterProperties {
  model?: Backbone.Model;
  permission: PermissionObject;
  hide: () => void;
  disabled: boolean;
  typeName: string;
  showDelete?: boolean;
}

const ModelEditModalFooter = ({
  model,
  permission,
  hide,
  disabled,
  typeName,
  showDelete = false, // de huidige modals 'repareren' van alles door de hele applicatie bij delete
}: ModelEditModalFooterProperties) => (
  <Modal.Footer>
    {showDelete && model?.id && permission.delete && (
      <DeleteButton
        confirmMsg={interpolate(
          gettext("Are you sure you want to delete this %s? \nthis cannot be undone!"),
          [typeName]
        )}
        onDelete={() => {
          model.destroy();
          hide();
        }}
      >
        {interpolate(gettext("Remove %s"), [typeName])}
      </DeleteButton>
    )}
    <CancelButton onClick={hide} />
    {permission.create && permission.update && <SaveButton disabled={disabled} />}
  </Modal.Footer>
);

export default ModelEditModalFooter;
